/**
 * Convert Date object to Date string in the format: "DD.MM.YYYY"
 *
 * We are NOT using Date.toLocaleDateString here because that method is for display only.
 * Edge (and possibly IE) add bi-directional control character to the locale date string.
 * https://github.com/Microsoft/ChakraCore/issues/599
 *
 * @param date the date to convert
 * @returns {string} date as string, DD.MM.YYYY
 */
export function getDateString(date) {
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  if (month.toString().length === 1) {
    month = '0' + month;
  }
  if (day.toString().length === 1) {
    day = '0' + day;
  }
  return `${day}.${month}.${year}`;
}

/**
 * Convert Date object to Date string in the format: "DD.MM.YYYY hh:mm"
 *
 * We are NOT using Date.toLocaleString here because that method is for display only.
 * Edge (and possibly IE) add bi-directional control character to the locale date string.
 * https://github.com/Microsoft/ChakraCore/issues/599
 *
 * @param date the date to convert
 * @returns {string} date as string, DD.MM.YYYY
 */
export function getDateWithTimeString(date) {
  const dateOnlyString = getDateString(date);
  let hour = date.getHours();
  let minute = date.getMinutes();
  if (hour.toString().length === 1) {
    hour = '0' + hour;
  }
  if (minute.toString().length === 1) {
    minute = '0' + minute;
  }
  return `${dateOnlyString} ${hour}:${minute}`;
}

/**
 * Takes a date string and parses the values for year, month, day, hour, minute, and seconds. All return values are of
 * type string, values that cannot be found will be "undefined".
 * Expected format of input string is one of:
 * - "DD.MM.YYYY[,] hh:mm:ss"
 * - YYYY-MM-DDThh:mm:ss (ISO without timezone)
 * The time can be omitted completely or partly.
 *
 * @param dateString string to parse, format see above
 * @returns {{year: string, month: string, day: string, hour: string, minute: string, second: string}} Parsed values
 */
export function extractFromDateString(dateString) {
  if (!dateString) {
    return undefined;
  }
  dateString = dateString.replace(/,/gi, '');

  const splittingCharacter = dateString.indexOf('T') > -1 ? "T" : " ";

  const [dateOnlyString, timeOnlyString = ""] = dateString.split(splittingCharacter);

  let month, day, year;
  if (dateOnlyString.indexOf('.') > -1) {
    [day, month, year] = dateOnlyString.split('.');
  } else {
    [year, month, day] = dateOnlyString.split('-');
  }

  const [hour, minute, second] = timeOnlyString.split(':');
  // hour = "" if timeOnlyString was ""

  return {
    year,
    month,
    day,
    hour: hour ? hour : undefined,
    minute,
    second
  };
}
